import React from 'react';
import { TeamInput } from '../../components/input/TeamInput';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const TeamPicker = ({
  onChange,
  schema: { title = 'Team', description = 'Select the responsible team' },
  required,
  rawErrors,
  formData,
  idSchema,
}: FieldExtensionComponentProps<string>) => {
  return (
    <TeamInput
      label={title}
      helperText={description}
      error={rawErrors && rawErrors.length > 0 && !formData}
      required={required}
      id={idSchema?.$id}
      onChange={onChange}
      value={formData as string}
    />
  );
};
